export class OtpResendModel {
  email: string | null = null;

  constructor() {}
}
